export enum ColumnType {
    ENUM,
    DATE,
    TEXT,
    BIG,
    IMAGE,
    LINK,
    LIST,
    NOTE
}